import { __decorate, __metadata, __param } from "tslib";
import { Component, Inject, Input } from '@angular/core';
import { MemberModelService } from '../../services/member-model.service';
var EACAcceptanceComponent = /** @class */ (function () {
    function EACAcceptanceComponent(memberModel) {
        this.memberModel = memberModel;
        this.pensionEACViewed = false;
        this.providentEACViewed = false;
        this.eacHide = false;
    }
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], EACAcceptanceComponent.prototype, "benefitType", void 0);
    EACAcceptanceComponent = __decorate([
        Component({
            selector: 'eacAcceptance',
            templateUrl: 'app/components/eac-acceptance/eac-acceptance.html'
        }),
        __param(0, Inject(MemberModelService)),
        __metadata("design:paramtypes", [Object])
    ], EACAcceptanceComponent);
    return EACAcceptanceComponent;
}());
export { EACAcceptanceComponent };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZWFjLWFjY2VwdGFuY2UuY29tcG9uZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vd29ya3BsYWNlTGl2aW5nU2VydmljZXMvc3JjL2FwcC9jb21wb25lbnRzL2VhYy1hY2NlcHRhbmNlL2VhYy1hY2NlcHRhbmNlLmNvbXBvbmVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxFQUFDLFNBQVMsRUFBRSxNQUFNLEVBQUUsS0FBSyxFQUFDLE1BQU0sZUFBZSxDQUFDO0FBRXZELE9BQU8sRUFBQyxrQkFBa0IsRUFBQyxNQUFNLHFDQUFxQyxDQUFDO0FBTXZFO0lBUUUsZ0NBQXNELFdBQVc7UUFBWCxnQkFBVyxHQUFYLFdBQVcsQ0FBQTtRQUoxRCxxQkFBZ0IsR0FBRyxLQUFLLENBQUM7UUFDekIsdUJBQWtCLEdBQUcsS0FBSyxDQUFDO1FBQzNCLFlBQU8sR0FBRyxLQUFLLENBQUM7SUFFNkMsQ0FBQztJQU41RDtRQUFSLEtBQUssRUFBRTs7K0RBQW9CO0lBRmpCLHNCQUFzQjtRQUpsQyxTQUFTLENBQUM7WUFDVCxRQUFRLEVBQUUsZUFBZTtZQUN6QixXQUFXLEVBQUUsbURBQW1EO1NBQ2pFLENBQUM7UUFTb0IsV0FBQSxNQUFNLENBQUMsa0JBQWtCLENBQUMsQ0FBQTs7T0FSbkMsc0JBQXNCLENBU2xDO0lBQUQsNkJBQUM7Q0FBQSxBQVRELElBU0M7U0FUWSxzQkFBc0IifQ==